(function () {
  if (window.__krimaaDelegatedTabsReady) return;
  window.__krimaaDelegatedTabsReady = true;

  function getTabs(grandparent) {
    return Array.from(grandparent.querySelectorAll('[role="tab"]'));
  }

  function activateTab(tab, moveFocus = false) {
    const grandparent = tab.closest('.tab-grand');
    if (!grandparent) return;

    const tabId = tab.getAttribute('aria-controls');
    if (!tabId) return;

    const selectedPanel = grandparent.querySelector(
      `#${CSS.escape(tabId)}`
    );
    if (!selectedPanel) return;

    const tabs = getTabs(grandparent);

    tabs.forEach((item) => {
      const selected = item === tab;

      item.setAttribute(
        'aria-selected',
        selected ? 'true' : 'false'
      );

      item.setAttribute(
        'tabindex',
        selected ? '0' : '-1'
      );
    });

    grandparent
      .querySelectorAll('.tab-content[role="tabpanel"]')
      .forEach((panel) => {
        const selected = panel === selectedPanel;

        if (selected) {
          panel.removeAttribute('hidden');
          panel.setAttribute('aria-hidden', 'false');
        } else {
          panel.setAttribute('hidden', '');
          panel.setAttribute('aria-hidden', 'true');
        }
      });

    if (moveFocus) {
      try {
        tab.focus({ preventScroll: true });
      } catch (e) {
        tab.focus();
      }
    }

    tab.dispatchEvent(
      new CustomEvent('krimaa:tab-shown', {
        bubbles: true,
        detail: {
          panel: selectedPanel,
          tab: tab
        }
      })
    );
  }

  /*
   * Delegated click listener:
   * survives Shopify AJAX / <main> replacement.
   */
  document.addEventListener(
    'click',
    function (event) {
      const tab = event.target.closest(
        '.tab-grand [role="tab"]'
      );

      if (!tab) return;

      event.preventDefault();
      activateTab(tab, false);
    },
    true
  );

  /*
   * Delegated keyboard navigation:
   * works independently for every tab section.
   */
  document.addEventListener(
    'keydown',
    function (event) {
      const currentTab = event.target.closest(
        '.tab-grand [role="tab"]'
      );

      if (!currentTab) return;

      const grandparent = currentTab.closest('.tab-grand');
      if (!grandparent) return;

      const tabs = getTabs(grandparent);
      if (tabs.length < 2) return;

      const currentIndex = tabs.indexOf(currentTab);
      if (currentIndex < 0) return;

      let nextIndex = null;

      if (
        event.key === 'ArrowRight' ||
        event.key === 'ArrowDown'
      ) {
        nextIndex = (currentIndex + 1) % tabs.length;
      }

      if (
        event.key === 'ArrowLeft' ||
        event.key === 'ArrowUp'
      ) {
        nextIndex =
          (currentIndex - 1 + tabs.length) % tabs.length;
      }

      if (event.key === 'Home') {
        nextIndex = 0;
      }

      if (event.key === 'End') {
        nextIndex = tabs.length - 1;
      }

      if (nextIndex === null) return;

      event.preventDefault();
      activateTab(tabs[nextIndex], true);
    },
    true
  );

  /*
   * Normalize initial tab state without attaching per-button listeners.
   */
  function normalizeTabs(root = document) {
    root.querySelectorAll('.tab-grand').forEach((grandparent) => {
      const tabs = getTabs(grandparent);
      if (!tabs.length) return;

      const selected =
        tabs.find(
          (tab) =>
            tab.getAttribute('aria-selected') === 'true'
        ) || tabs[0];

      activateTab(selected, false);
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener(
      'DOMContentLoaded',
      function () {
        normalizeTabs();
      },
      { once: true }
    );
  } else {
    normalizeTabs();
  }

  document.addEventListener(
    'shopify:section:load',
    function (event) {
      normalizeTabs(event.target || document);
    }
  );
})();
